import { useState, useEffect } from 'react';
import { discussionService } from '@services/discussionService';

interface DiscussionImageProps {
    filename: string;
    userId: string;
    alt: string;
    className?: string;
}

const DiscussionImage = ({ filename, userId, alt, className }: DiscussionImageProps) => {
    const [imageUrl, setImageUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const loadImage = async () => {
            try {
                setLoading(true);
                setError(false);
                const url = await discussionService.getImageUrl(filename, userId);
                if (url) {
                    setImageUrl(url);
                } else {
                    setError(true);
                }
            } catch (err) {
                console.error('Error loading image:', err);
                setError(true);
            } finally {
                setLoading(false);
            }
        };

        loadImage();
    }, [filename, userId]);

    if (loading) {
        return (
            <div className={`bg-white/5 rounded-2xl border border-white/10 animate-pulse ${className}`} style={{ minHeight: '200px' }} />
        );
    }

    if (error || !imageUrl) {
        return (
            <div className={`bg-white/5 rounded-2xl border border-white/10 flex items-center justify-center ${className}`} style={{ minHeight: '200px' }}>
                <p className="text-white/40 text-sm">Failed to load image</p>
            </div>
        );
    }

    return (
        <img
            src={imageUrl}
            alt={alt}
            className={className}
        />
    );
};

export default DiscussionImage;
